import http from '../utils/http';
import { interpolate, unParseQuery } from 'utils/string';
import { SKILL_CATEGORY_URL, SKILL_CATEGORY_ABSOLUTE_URL } from '../constants/endpoints';
import type { SkillCategory } from 'interface/skill';
import type { ServiceId, ServiceParams } from 'interface/service';

export async function fetchAll(params: ServiceParams = {}) {
  const data = await http.get(SKILL_CATEGORY_URL + unParseQuery(params));

  return data;
}

export async function fetchById(id: ServiceId) {
  const { data } = await http.get(interpolate(SKILL_CATEGORY_ABSOLUTE_URL, { id }));

  return data;
}

export async function create(skillCategory: SkillCategory) {
  return await http.post(SKILL_CATEGORY_URL, {
    body: skillCategory,
  });
}

export async function update(skillCategory: SkillCategory, id: ServiceId) {
  return await http.put(interpolate(SKILL_CATEGORY_ABSOLUTE_URL, { id }), {
    body: skillCategory,
  });
}

export async function remove(id: ServiceId) {
  return await http.delete(interpolate(SKILL_CATEGORY_ABSOLUTE_URL, { id }));
}
